import { AlertTriangle, ChevronDown, Users } from "lucide-react";

/**
 * Resumo das informações da mesa (Nº da comanda · pessoas · cliente) que abre
 * e fecha o formulário. `compacto` = no celular, na mesma linha do "Mesa 01"
 * (dono, 25/09/2026: liberar espaço na tela); sem ele = a barra larga do
 * computador. Com observação preenchida, mostra o ⚠.
 */
export default function ResumoInfoMesa({ comanda, pessoas, cliente, observacao, aberto, onAlternar, compacto = false, className = "" }) {
  return (
    <button
      type="button"
      onClick={onAlternar}
      aria-expanded={aberto}
      data-e2e={compacto ? "mesa-info-cabecalho" : "mesa-info-barra"}
      className={`flex items-center gap-1.5 rounded-lg border border-orange-400/40 bg-orange-50/50 dark:bg-orange-500/5 text-xs min-w-0 touch-manipulation ${
        compacto ? "px-2.5 h-10" : "w-full gap-2 px-3 py-2"} ${className}`}
    >
      <span className="inline-flex items-center gap-1 text-muted-foreground shrink-0">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-orange-500" />
        <span className={`font-mono font-bold ${comanda ? "text-foreground" : "text-muted-foreground/60"}`}>{comanda ? `#${comanda}` : "Nº"}</span>
      </span>
      <span className="text-border shrink-0">·</span>
      <span className="inline-flex items-center gap-1 text-muted-foreground shrink-0">
        <Users className="w-3 h-3" />
        <span className={`font-mono font-bold ${pessoas ? "text-foreground" : "text-muted-foreground/60"}`}>{pessoas || "0"}</span>
      </span>
      <span className="text-border shrink-0">·</span>
      <span className="flex-1 min-w-0 text-left truncate">
        {cliente ? <span className="font-semibold text-foreground">{cliente}</span> : <span className="text-muted-foreground/60">Cliente</span>}
      </span>
      {String(observacao || "").trim() && <AlertTriangle className="w-3.5 h-3.5 text-amber-500 shrink-0" aria-label="Tem observação" />}
      <ChevronDown className={`w-4 h-4 text-orange-500 flex-shrink-0 transition-transform ${aberto ? "rotate-180" : ""}`} />
    </button>
  );
}
